export class loginForm {
  name: string = '';
  password: string = ''
}
